import { ReactElement } from 'react';

import { styled, TableCell, TableHead, TableRow } from '@mui/material';

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: 'white !important',
  padding: '0px 16px',
  fontWeight: 400,
  color: theme.palette.gray500.main,
  borderBottom: `1px solid ${theme.palette.gray200.main}`,
}));

export const RecentActivityTableHead = (): ReactElement => {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: 'red' }}>
        <CustomTableCell>Date</CustomTableCell>
        <CustomTableCell sx={{ whiteSpace: 'nowrap' }}>
          Experience Description
        </CustomTableCell>
        <CustomTableCell>Type</CustomTableCell>
        <CustomTableCell>Credits</CustomTableCell>
        <CustomTableCell>Balance</CustomTableCell>
      </TableRow>
    </TableHead>
  );
};
